



























































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import { find, forEach, findIndex, filter } from 'lodash'
import Question from '../models/Question'
import { LETTER_FORMAT } from '../../client/utils/constants'
import QuestionBodyComponent from './QuestionBodyComponent.vue'
import { isArray } from 'util'
import ProgressRotate from '../../client/components/atoms_molecules/ProgressRotate.vue'
import ChartProgress from '../../client/components/atoms_molecules/ChartProgress.vue'
import {
  State as StateEditor,
  Getter as GetterEditor,
  Action as ActionEditor,
  Mutation as MutationEditor
} from '../store-helper'
import { qEditorState } from '../stores'

@Component({
  components: {
    QuestionBodyComponent,
    ProgressRotate,
    ChartProgress
  }
})
export default class QuestionComponent extends Vue {
  LETTER_FORMAT = LETTER_FORMAT
  reRender: string = Date().toString()
  time = 20
  score = 0
  totalScore = 0
  isAnswered = false

  get questions() {
    return qEditorState.questions
  }

  get currentPage() {
    return qEditorState.displayCurrentPage
  }

  get question() {
    return qEditorState.question
  }

  @Watch('question')
  onQuestionChange() {
    this.onUnAnswer()
  }

  get groupQuestions(): Question[] {
    if (!this.question) return []
    const groupQuestions = this.questions.filter(question => this.question!.group == question.group)
    return groupQuestions
  }

  get questionsIgnoreDescription(): Question[] {
    return this.questions.filter((q) => !q.isDescriptionQuestion)
  }

  get groupNumber(): number {
    const groupList: number[] = []
    this.questionsIgnoreDescription.forEach((question) => {
      if (groupList.indexOf(question.group) < 0) {
        groupList.push(question.group)
      }
    })
    return groupList.indexOf(this.question!.group)
  }

  get questionNumber() {
    return this.questions.indexOf(this.question!) + 1
  }

  get totalQuestionNumber() {
    return this.questions.length
  }

  get groupQuestionSize() {
    return this.groupQuestions.length
  }

  get isSingleQuestion() {
    return this.groupQuestionSize === 1
  }

  onAnswerQuestion(score, totalScore) {
    this.score += score
    this.totalScore += totalScore
  }

  first() {
    qEditorState.changePage({ page: 1 })
  }

  previous() {
    qEditorState.changePage({ page: this.currentPage - 1 })
  }

  next() {
    qEditorState.changePage({ page: this.currentPage + 1 })
  }

  last() {
    qEditorState.changePage({ page: this.totalQuestionNumber })
  }

  onAnswer() {
    this.isAnswered = true
  }

  onUnAnswer() {
    this.score = 0
    this.totalScore = 0
    this.isAnswered = false
  }
}
